<template>
    <div>
        <div class="is-main f-mb15">
            <div class="container" style="padding: 0;">
                <div style="padding: 0 15px;">
                    <section class="m-location f-mb10">
                        <span>当前位置：</span>
                        <a href="/">网站首页</a> &gt;
                        <a>交易详情</a>
                    </section>
                </div>


                <div class="m-pgpdbox1" style="padding: 20px 15px 0;background: white;">
                    <div class="m-detailbox">
                        <h1 class="u-lgtit text-center f-mb15 f-md-mb10">{{ tradeDetail.title }}</h1>
                        <div class="m-dtfuns f-clearfix"
                            :class="{ noneBorder: tradeDetail.type != 5 && tradeDetail.type != 6 }">
                            <div class="u-wzinfo f-fl f-md-fn">
                                <span>信息时间：{{ tradeDetail.time }}</span>
                                <span v-if="tradeDetail.author">作者：{{ tradeDetail.author }}</span>
                                <span v-if="tradeDetail.views">浏览：{{ tradeDetail.views }} 次</span>
                            </div>
                        </div>
                        <div class="m-dtfuns f-clearfix" style="border: 0;"
                            v-if="tradeDetail.type != 5 && tradeDetail.type != 6">
                            <el-tabs stretch v-model="queryData.progressStatus"
                                @tab-click="gettradeDetail(queryData.progressStatus)">
                                <el-tab-pane v-for="item in progressList" :key="item.id" :label="item.name"
                                    :disabled="!isAvailable(item.id)" :name="item.id + ''">
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <!-- <div class="m-dtfuns f-clearfix"
                            style="display: flex;flex-wrap: wrap; background-color: #edfbff;border: 1px solid #68cce5;text-align: center;justify-content:flex-end">
                            <div v-for="item in progressList" :key="item.id" style="flex-basis: 20%;height: 65px;margin: 10px 0">
                                <div style="background-color: #27bee4;width: 80%;color: #fff;height: 100%;display: flex; align-items: center;justify-content: center;border-radius: 5px;">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div> -->
                        <div class="m-dtfonts">

                            <div class="m-dttexts f-clearfix j-fontContent no-indent" ref="htmlContainer" id="zoom"
                                v-html="tradeDetail.detail"></div>
                        </div>
                        <div class="m-dtdownload f-mb15">
                            <ul>
                            </ul>
                        </div>
                        <div class="m-btfuns f-clearfix f-mb15">
                            <ul class="f-fr">
                                <li class="u-gotp j-goTop">
                                    <a :href="getFileUrl(item)" target="_blank" v-for="(item, index) in tradeDetail.files"
                                        :key="index">
                                        {{ '附件: ' + getFilesName(item) }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/api'

export default {
    name: "detail",
    data() {
        return {
            tradeDetail: {},
            next: {},
            prev: {},
            progressStatus: [],
            progressList: [{
                id: 1,
                name: "项目登记"
            }, {
                id: 2,
                name: "采购公告文件发布"
            }, {
                id: 3,
                name: "答疑、澄清、更正公告"
            }, {
                id: 9,
                name: "中标候选人公示"
            }, {
                id: 4,
                name: "中标（成交）结果公告"
            }, {
                id: 5,
                name: "中标通知书发放"
            }, {
                id: 8,
                name: "履约及变更信息公开"
            }, {
                id: 6,
                name: "合同公告"
            }, {
                id: 7,
                name: "暂停、终止招标"
            },],
            queryData: {
                progressStatus: undefined
            }
        }
    },
    computed: {
        isAvailable() {
            return function (progress) {
                for (let index = 0; index < this.progressStatus.length; index++) {
                    const item = this.progressStatus[index];
                    if (item.progress == progress) {
                        return true
                    }

                }
                return false
            }
        },
        getFilesName() {
            return item => {
                return item.slice(53)
            }
        },

        getFileUrl() {
            return item => {

                return item.slice(0,53) + encodeURIComponent(item.slice(53))
            }
        }

    },
    created() {
        // this.activeId = this.$route.params.id
        // console.log(this.$route.params)
        this.gettradeDetail(this.$route.params.progress)
        this.getTradeProgressStatus(this.$route.params.parentId)
    },
    methods: {

        removeTextIndent() {
            const container = this.$refs.htmlContainer;
            if (container) {
                const allElements = container.querySelectorAll('*');
                // console.log('allElements', allElements)
                allElements.forEach(el => {
                    el.style.textIndent = ''; // 移除 text-indent 样式
                });
            }
        },
        getTradeProgressStatus(id) {
            api.tradeProgressStatus(id).then(list => {
                this.progressStatus = list;
            })
        },
        gettradeDetail(progress) {
            api.tradeItemByProgress(this.$route.params.parentId, progress).then(res => {
                if (res == null) return

                let head = document.getElementsByTagName("head")    // 修改meta
                let meta = document.createElement("meta")
                meta.content = res.description

                if (this.$store.state.meta != null) {
                    head[0].replaceChild(meta, this.$store.state.meta)
                } else {
                    head[0].appendChild(meta)
                }
                this.$store.state.meta = meta


                this.tradeDetail = res
                this.queryData.progressStatus = res.progress + '';
                if (this.tradeDetail.files != null) {
                    this.tradeDetail.files = JSON.parse(this.tradeDetail.files)
                }
                this.$nextTick(() => {
                    this.removeTextIndent();
                });
                // this.next = res.next
                // this.prev = res.prev
            })
        },

    },

    // watch: {
    //     '$store.state.activeArticleId': function(newValue) {
    //         this.gettradeDetail(newValue)
    //     }
    // }
}
</script>

<style scoped>
.noneBorder {
    border: 0 !important;
}
</style>
